import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { blue, indigo } from "@mui/material/colors";
import { Helmet } from "react-helmet";

// Pages
import SearchEnroll from "./pages/SearchEnroll/SearchEnroll";
import ApprovedVendors from "./pages/ApprovedVendors/ApprovedVendors";

// Components
import ScrollToTop from "./components/ScrollToTop";

// Get website type from environment variables
const WEBSITE_TYPE = process.env.REACT_APP_WEBSITE_TYPE || "WEA";
const WEBSITE_DISPLAY_NAME = WEBSITE_TYPE === "MB" ? "Member Benefits" : "WEA";

// Theme configuration
const theme = createTheme({
  palette: {
    primary: {
      main: blue[900],
    },
    secondary: {
      main: indigo[700],
    },
  },
  typography: {
    fontFamily: ['"Lato"', "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>{WEBSITE_DISPLAY_NAME} Enrollment Site</title>
        <meta name="description" content={`${WEBSITE_DISPLAY_NAME} Enrollment Site`} />
      </Helmet>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/search-enroll/:employerId/:empState/approved-vendor" element={<ApprovedVendors />} />
            <Route path="/search-enroll/:employerId" element={<SearchEnroll />} />
            <Route path="/search-enroll" element={<SearchEnroll />} />
            <Route path="*" element={<Navigate to="/search-enroll" />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </ThemeProvider>
  );
}

export default App;
